/* Shower Simply: alcove steppers, remembered alcove size and ZIP, fit filtering on collection pages. */
(() => {
  const KEY = 'ss-fit';
  const read = () => {
    try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch (e) { return {}; }
  };
  const write = (v) => {
    try { localStorage.setItem(KEY, JSON.stringify({ ...read(), ...v })); } catch (e) { /* storage unavailable */ }
  };

  const clamp = (n, min, max) => Math.min(max, Math.max(min, n));

  function initSteppers(root = document) {
    root.querySelectorAll('[data-ss-stepper]').forEach((stepper) => {
      if (stepper.dataset.ready) return;
      stepper.dataset.ready = '1';
      const input = stepper.querySelector('input');
      stepper.querySelectorAll('button[data-step]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const min = Number(input.min) || 0;
          const max = Number(input.max) || 999;
          const next = clamp((Number(input.value) || min) + Number(btn.dataset.step), min, max);
          input.value = String(next);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  function initFitForms() {
    const saved = read();
    document.querySelectorAll('[data-ss-fit-form]').forEach((form) => {
      const w = form.querySelector('[name="w"]');
      const d = form.querySelector('[name="d"]');
      const zip = form.querySelector('[data-ss-zip]');
      if (saved.w && w) w.value = saved.w;
      if (saved.d && d) d.value = saved.d;
      if (saved.zip && zip) zip.value = saved.zip;
      form.addEventListener('submit', (event) => {
        if (zip && zip.value && !/^\d{5}$/.test(zip.value)) {
          event.preventDefault();
          zip.setAttribute('aria-invalid', 'true');
          zip.focus();
          return;
        }
        write({ w: w && w.value, d: d && d.value, zip: zip && zip.value });
      });
    });
  }

  /* Collection pages: cards carry data-fit-* from product metafields. Cards that fit move first and get a badge. */
  function applyFitToCollection() {
    const params = new URLSearchParams(location.search);
    const w = Number(params.get('w'));
    const d = Number(params.get('d'));
    if (!w || !d) return;
    write({ w, d, zip: params.get('zip') || read().zip });
    const cards = document.querySelectorAll('[data-fit-wmin]');
    let fits = 0;
    cards.forEach((card) => {
      const ok =
        w >= Number(card.dataset.fitWmin) && w <= Number(card.dataset.fitWmax) &&
        d >= Number(card.dataset.fitDmin) && d <= Number(card.dataset.fitDmax);
      card.toggleAttribute('data-fits', ok);
      if (ok) fits += 1;
    });
    const note = document.querySelector('[data-ss-fit-note]');
    if (note) {
      note.hidden = false;
      note.textContent = fits
        ? `${fits} ${fits === 1 ? 'shower fits' : 'showers fit'} a ${w} × ${d} in alcove.`
        : `Nothing in this collection fits a ${w} × ${d} in alcove exactly. Call us and we will find a size that works.`;
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    initSteppers();
    initFitForms();
    applyFitToCollection();
  });
  document.addEventListener('shopify:section:load', (e) => initSteppers(e.target));
})();
